<mat-card appearance="outlined" class="ai-cost">
  <mat-card-content>
    <div class="ai-cost__head">
      <h3 class="ai-cost__title">
        <app-icon name="wallet" [size]="18" />
        AI cost
      </h3>
      @if (breakdown(); as b) {
        <div class="ai-cost__total">
          <span class="ai-cost__total-zar">ZAR {{ b.total_cost_zar | number: '1.4-4' }}</span>
          <span class="ai-cost__total-usd">${{ b.total_cost_usd | number: '1.4-4' }}</span>
        </div>
      }
    </div>

    @if (loading()) {
      <p class="ai-cost__muted">Loading…</p>
    } @else if (!hasCalls()) {
      <p class="ai-cost__muted">No AI spend recorded for this application yet.</p>
    } @else if (breakdown(); as b) {
      <!-- Per-purpose roll-up -->
      <ul class="ai-cost__purposes" aria-label="AI cost by type">
        @for (p of b.by_purpose; track p.purpose) {
          <li class="ai-cost__purpose">
            <span class="ai-cost__purpose-name">{{ p.purpose_display }}</span>
            <span class="ai-cost__purpose-count"
              >{{ p.count }} call{{ p.count === 1 ? '' : 's' }}</span
            >
            <span class="ai-cost__purpose-cost">ZAR {{ p.cost_zar | number: '1.4-4' }}</span>
          </li>
        }
      </ul>

      <!-- Individual calls -->
      <table class="ai-cost__table">
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Model</th>
            <th scope="col" class="ai-cost__num">Tokens</th>
            <th scope="col" class="ai-cost__num">ZAR</th>
            <th scope="col">When</th>
          </tr>
        </thead>
        <tbody>
          @for (call of b.calls; track call.short_id) {
            <tr [class.ai-cost__row--failed]="call.status === 'FAILED'">
              <td>{{ call.purpose_display }}</td>
              <td class="ai-cost__model">{{ call.model }}</td>
              <td class="ai-cost__num">
                {{ call.total_input_tokens | number }} / {{ call.output_tokens | number }}
              </td>
              <td class="ai-cost__num">{{ call.cost_zar | number: '1.4-4' }}</td>
              <td class="ai-cost__when">{{ call.created_at | date: 'medium' }}</td>
            </tr>
          }
        </tbody>
      </table>

      <p class="ai-cost__foot">
        Tokens shown as input / output. Costs are computed from token usage at list price; USD is
        the billed currency, ZAR a convenience conversion.
      </p>
    }
  </mat-card-content>
</mat-card>
